import React from 'react';
import {FieldPath, FieldPathValue, FieldValues, useFormContext} from 'react-hook-form';

export function useFieldValueGetter<TFieldValues extends FieldValues>(
   globName?: any,
   _defaultValue?: any
) {
   const methods = useFormContext<TFieldValues>();
   return React.useCallback(
      <TFieldName extends FieldPath<TFieldValues>>(
         name: TFieldName,
         defaultValue?: FieldPathValue<TFieldValues, TFieldName>
      ): FieldPathValue<TFieldValues, TFieldName> => {
         return methods.watch(name || globName) || defaultValue || _defaultValue;
      },
      [methods?.watch, globName]
   );
}
